module.exports = require("crypto");


//////////////////
// WEBPACK FOOTER
// external "crypto"
// module id = 197
// module chunks = 0